module.exports = __webpack_public_path__ + "img/jinqiu.1ceb4672.png";